import styled from "@emotion/styled";
import { Tab } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import { Button } from "@weng-lab/psychscreen-ui-components";

export const StyledTab = styled(Tab)(() => ({
  textTransform: "none" as any,
}));

export const StyledButton = styled(Button)(() => ({
  textTransform: "none" as any,
}));

export const StyledToggleButton = styled(ToggleButton)(() => ({
  textTransform: "none" as any,
}));

